const MAX_LOGGED_SECTION_LENGTH = 64;

/** Whether `pathname` is `prefix` or under it. Case-insensitive, like the router's own matching. */
export function isUnderPathPrefix(pathname: string, prefix: string): boolean {
  const lowerPathname = pathname.toLowerCase();
  return lowerPathname === prefix || lowerPathname.startsWith(`${prefix}/`);
}

/**
 * The first path segment after `prefix` (e.g. `calendar`), or `(root)`. Used in logs so no IDs are recorded;
 * capped in length because the path comes from the URL, and lowercased because the router ignores case.
 */
export function getPathSection(pathname: string, prefix: string): string {
  const [section] = pathname.slice(prefix.length).split("/").filter(Boolean);
  return section ? section.slice(0, MAX_LOGGED_SECTION_LENGTH).toLowerCase() : "(root)";
}
